export default {"src":"/_next/static/media/missile_cat_ic.a7d6cc1b.svg","height":120,"width":120};